module.exports = __webpack_public_path__ + "static/media/Headerlogo.cdad258d.png";